import {keyBy} from "lodash";
import {IStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getSquads = (store: IStore) => store.squads;

export const getSquadsById = createSelector([getSquads], (squads) => keyBy(squads, "id"));

export const getSquadsByIds = createSelector(
	[getSquadsById],
	(squads) => (squadIds: (number | undefined)[] | string[]) => {
		return squadIds.map((id) => (id ? squads[id] : null));
	}
);
